/* eslint-disable semi,semi-style */
export const getQueryString = (name, searchString = window.location.search) => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = searchString.substr(1).match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

export const typeOf = (param) => {
  return Object.prototype.toString.call(param).slice(8, -1).toLowerCase()
}